import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

const firebaseConfig = {
  apiKey: 'AIzaSyBskCizlQCQCD8lOh2tyzI0eLyYYfSoUHw',
  authDomain: 'agentwatch-fb5a3.firebaseapp.com',
  projectId: 'agentwatch-fb5a3',
  storageBucket: 'agentwatch-fb5a3.firebasestorage.app',
  messagingSenderId: '714315402821',
  appId: '1:714315402821:web:e94f14acc99cdd712bdd2c',
  measurementId: 'G-CDR7HNMT3J',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);
export default app;
